// @flow
import React, { Component, Fragment } from 'react';
import {
    Button,
    Checkbox,
    Form,
    Grid,
    Header,
    List,
    Message,
    Modal,
    Radio,
    Segment,
    Transition
} from 'semantic-ui-react';

import { Link } from 'react-router-dom';
import { capitalize, setMessage } from 'tools';
import './Filter.scss';

type Props = {
    consumers: any
}

type State = {
    loading: boolean,
    visible: boolean,
    error: boolean,
    modalCcns: boolean,
    message: any,
    dispositions: {
        prevoyance: boolean,
        sante: boolean,
    },
    colleges: {
        cadres: boolean,
        nonCadres: boolean,
        ensemble: boolean,
    },
    garantie: string,
    filteredResults: any
}

/**
 * Favorites
 * @author Tomasz tpr@deltacode.fr
 * @memberof Containers
 * @extends {React.Component}
 * @description Favorites container
 */
class Filter extends Component<Props, State> {

    /**
     * @constructor
     * @param { Object } props Props
     */
    constructor(props: Props) {
        super(props)
        this.state = {
            error: false,
            visible: true,
            loading: false,
            modalCcns: false,
            message: {},
            dispositions: {
                prevoyance: false,
                sante: false,
            },
            colleges: {
                cadres: false,
                nonCadres: false,
                ensemble: false,
            },
            garantie: "",
            filteredResults: null
        }
    }

    handleCcnsModalOpen = async (event: SyntheticEvent<HTMLButtonElement>, id: number) => {
        /**
         * @instance
         * @async
         * @method handleReviewsModalOpen
         * @memberof Containers.CustomComponent
         * @description  Open confirmation modal
         * @return { Void } 
         */

        this.setState({ modalCcns: true });
    }

    handleCcnsModalClose = async (event: SyntheticEvent<HTMLButtonElement>, id: number) => {
        /**
         * @instance
         * @async
         * @method handleReviewsModalClose
         * @memberof Containers.CustomComponent
         * @description  Close confirmation modal
         * @return { Void } 
         */
        this.setState({ modalCcns: false });
    }

    handleSubmit = async () => {
        try {
            // Active le loader
            this.setState({ loading: true, error: false });
            const { filter } = this.props.consumers;
            const { dispositions, colleges, garantie } = this.state;

            // Prépare les paramètres
            const payload = {
                dispositions: [
                    ...(dispositions.prevoyance ? ["PREVOYANCE"] : []),
                    ...(dispositions.sante ? ["SANTE"] : []),
                ],
                colleges: [
                    ...(colleges.cadres ? ["CADRES"] : []),
                    ...(colleges.nonCadres ? ["NOCADRES"] : []),
                    ...(colleges.ensemble ? ["ENSEMBLE"] : []),
                ],
                guarantees: garantie
            };

            // 🔥 Appel de ton consumer filter
            const result = await filter.getFilteredCcns(payload);

            // Mets à jour ton état (selon ce que ton API renvoie)
            this.setState({
                loading: false,
                message: {
                    color: "green",
                    text: "Filtrage effectué avec succès !",
                },
                filteredResults: result, // si tu veux les stocker
                modalCcns: true
            });
        } catch (error) {
            console.error("Erreur lors du filtrage :", error);
            this.setState({
                loading: false,
                error: true,
                message: setMessage("Erreur lors du filtrage", error.status),
            });
        }
    };



    render() {
        /**
         * @instance
         * @method render
         * @memberof Containers.Favorites
         * @return { String } JSX 
         */
        const { loading, error, visible, modalCcns, message, dispositions, colleges, garantie } = this.state;

        const hasDisposition = Object.values(dispositions).some(Boolean);
        const hasCollege = Object.values(colleges).some(Boolean);
        const hasGarantie = garantie !== '';
        const isDisabled = !(hasDisposition && hasCollege && hasGarantie);

        return (
            <Fragment>
                <Modal className='result' open={modalCcns} centered={false}>
                    <Modal.Header>Résultats du filtrage</Modal.Header>
                    <Modal.Content scrolling>
                        <Modal.Description>
                            {this.state.filteredResults && this.state.filteredResults.length > 0 ? (
                                <List divided verticalAlign="middle" className="results">
                                    {this.state.filteredResults.map((item, index) => (
                                        <List.Item key={index}>
                                            <Link to={{
                                                pathname: `/ccn/${item.ref}`, state: {
                                                    description: item.description,
                                                    id: item.ref,
                                                    idcc: item.idcc,
                                                    title: item.title,
                                                    scope: "ccn"
                                                }
                                            }}>
                                                <List.Header as='h3'
                                                    style={{ fontWeight: "400"}}
                                                    className="color-default" >CCN {item.idcc} - {capitalize(item.description)}</List.Header>
                                                <List.Content>
                                                    <List.Description>
                                                        {item.nom || item.title || "Aucune description"}
                                                    </List.Description>
                                                </List.Content>
                                            </Link>
                                        </List.Item>
                                    ))}
                                </List>
                            ) : (
                                <Message info content="Aucun résultat trouvé." />
                            )}
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button className="button btn default" size='small' onClick={this.handleCcnsModalClose}>Fermer </Button>
                    </Modal.Actions>
                </Modal>
                <Grid className="Filter page bg-gradient" >
                    <Grid.Row >
                        <Grid.Column>
                            <Transition visible={visible} animation='fade up' duration={500}>
                                <Header as='h2' textAlign='center' className='lead'>
                                    Filtrer les CCN
                                </Header>
                            </Transition>
                            <Fragment>
                                {error ? (
                                    <Segment>
                                        <Message color={message.color} content={message.text} />
                                    </Segment>
                                ) : (
                                    <Segment textAlign="center" className="color-default">
                                        <Form>
                                            <Header as="h3">Sélectionnez les dispositions recherchées</Header>
                                        <div style={{ display: "flex", margin: "auto", width:"fit-content" }}>
                                            <Form.Field>
                                                <Checkbox
                                                    label="Prévoyance"
                                                    style={{ marginRight: "1em" }}
                                                    checked={this.state.dispositions?.prevoyance || false}
                                                    onChange={() =>
                                                        this.setState({
                                                            dispositions: {
                                                                ...this.state.dispositions,
                                                                prevoyance: !this.state.dispositions?.prevoyance,
                                                            },
                                                        })
                                                    }
                                                />
                                            </Form.Field>
                                            <Form.Field>
                                                <Checkbox
                                                    label="Santé"
                                                    checked={this.state.dispositions?.sante || false}
                                                    onChange={() =>
                                                        this.setState({
                                                            dispositions: {
                                                                ...this.state.dispositions,
                                                                sante: !this.state.dispositions?.sante,
                                                            },
                                                        })
                                                    }
                                                />
                                            </Form.Field>
                                            </div>
                                            <Header as="h3" style={{ marginTop: "1em" }}>
                                                Sélectionnez les collèges recherchés
                                            </Header>
                                            <div style={{ display: "flex", margin: "auto", width:"fit-content" }}>
                                            <Form.Field>
                                                <Checkbox
                                                    label="Cadres"
                                                    checked={this.state.colleges?.cadres || false}
                                                    onChange={() =>
                                                        this.setState({
                                                            colleges: {
                                                                ...this.state.colleges,
                                                                cadres: !this.state.colleges?.cadres,
                                                            },
                                                        })
                                                    }
                                                />
                                            </Form.Field>
                                            <Form.Field>
                                                <Checkbox
                                                    label="Non cadres"
                                                    style={{ margin: "0 1em"}}
                                                    checked={this.state.colleges?.nonCadres || false}
                                                    onChange={() =>
                                                        this.setState({
                                                            colleges: {
                                                                ...this.state.colleges,
                                                                nonCadres: !this.state.colleges?.nonCadres,
                                                            },
                                                        })
                                                    }
                                                />
                                            </Form.Field>
                                            <Form.Field>
                                                <Checkbox
                                                    label="Ensemble du personnel"
                                                    checked={this.state.colleges?.ensemble || false}
                                                    onChange={() =>
                                                        this.setState({
                                                            colleges: {
                                                                ...this.state.colleges,
                                                                ensemble: !this.state.colleges?.ensemble,
                                                            },
                                                        })
                                                    }
                                                />
                                            </Form.Field>
                                            </div>
                                            <Header as="h3" style={{ marginTop: "1em" }}>
                                                Quel type d'obligations recherchez-vous ?
                                            </Header>
                                            <div style={{ display: "flex", margin: "auto", width:"fit-content" }}>
                                            <Form.Field>
                                                <Radio
                                                    label="Sans garanties"
                                                    name="garantie"
                                                    value="GREEN"
                                                    checked={this.state.garantie === "GREEN"}
                                                    onChange={(_, { value }) => this.setState({ garantie: value })}
                                                />
                                            </Form.Field>
                                            <Form.Field>
                                                <Radio
                                                    label="Avec garanties"
                                                    name="garantie"
                                                    value="YELLOW"
                                                    checked={this.state.garantie === "YELLOW"}
                                                    onChange={(_, { value }) => this.setState({ garantie: value })}
                                                    style={{ margin: "0 1em" }}
                                                />
                                            </Form.Field>
                                            <Form.Field>
                                                <Radio
                                                    label="Avec garanties et assureurs"
                                                    name="garantie"
                                                    value="ORANGE"
                                                    checked={this.state.garantie === "ORANGE"}
                                                    onChange={(_, { value }) => this.setState({ garantie: value })}
                                                />
                                            </Form.Field>
                                            </div>
                                            <Button
                                                style={{ marginTop: "2em" }}
                                                content={this.state.loading ? "Chargement..." : "Valider"}
                                                loading={this.state.loading}
                                                disabled={this.state.loading || isDisabled}
                                                onClick={this.handleSubmit}
                                                className="btn default"
                                                size="large"
                                            />
                                        </Form>

                                    </Segment>
                                )}
                            </Fragment>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Fragment>
        )
    }
}

export { Filter };
